import { Box, Typography, styled } from '@mui/material';

import { FONT_FAMILY } from '@/shared/ui/form-fields/fieldStyles';

export const DetailsCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '0.75rem',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  alignSelf: 'stretch',
  gap: '1.5rem',
}));

export const DetailsCardTitle = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '1.125rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '125%',
  letterSpacing: 0,
  color: theme.palette.grey[900],
}));

export const DetailsGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 11rem)) max-content',
  justifyContent: 'space-between',
  columnGap: '1rem',
  rowGap: '1rem',
});

export const DetailLabel = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '100%',
  letterSpacing: '0.28px',
  textTransform: 'uppercase',
  color: theme.palette.grey[900],
}));

export const DetailValue = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '0.875rem',
  fontWeight: 350,
  lineHeight: 1.3,
  letterSpacing: 0,
  color: theme.palette.grey[900],
  overflowWrap: 'anywhere',
}));

export const SectionCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '0.75rem',
  backgroundColor: theme.palette.common.white,
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const AwbNumberText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '1.875rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 1.2,
  letterSpacing: 0,
  color: theme.palette.grey[900],
}));

export const FieldsGrid = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'columns',
})<{ columns: number }>(({ columns }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  columnGap: '1rem',
  rowGap: '1rem',
  alignItems: 'start',
}));

export const Notice = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: 'warning' | 'info' }>(({ theme, tone }) => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  gap: '0.5rem',
  minHeight: '2.1875rem',
  padding: '0.5rem 1.25rem',
  borderRadius: '0.75rem',
  backgroundColor: tone === 'warning' ? theme.palette.orange[100] : theme.palette.blue[50],
  color: tone === 'warning' ? theme.palette.orange[600] : theme.palette.blue[500],
  fontFamily: FONT_FAMILY,
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 350,
  lineHeight: '125%',
  letterSpacing: 0,
  flexShrink: 0,
}));
